class StorageManager {
  constructor(key) {
    this.key = key;
  }
  save(obj) {
    const jsonString = window.btoa(JSON.stringify(obj));
    sessionStorage.setItem(this.key, jsonString);
  }
  get() {
    const jsonString = JSON.parse(sessionStorage.getItem(this.key));   
    return jsonString ;
  }
  remove() {
    sessionStorage.removeItem(this.key);
  }
}

const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { StorageManager, getLoggedinUser };
